import utility from './utility'
import axios from 'axios'

export default {
  getErrorMessage: function (imageUuid, apiClient = axios.create(JSON.parse(process.env.AXIOS_PARAMS))) {
    const checkImportUrl = `${process.env.API_IMPORT_MANAGER_SEARCH_ENDPOINT}`
    const url = `${checkImportUrl}${imageUuid}&sort=id,DESC`

    return apiClient
      .get(url)
      .then(response => {
        let errorMessage = "Impossibile visualizzare l'immagine"
        let images = response.data._embedded.images
        const imageToCheck = images[images.length - 1]

        const importInProgress = !imageToCheck.overall || imageToCheck.overall.importState !== 'DONE'

        if (importInProgress) {
          errorMessage = 'Importazione immagine in corso'
        }
        return errorMessage
      })
      .catch(() => "Impossibile visualizzare l'immagine")
  },
  getMetaData: function (metaEndpoint, uuid) {
    return this.getPpiAndConstraintsUrl(metaEndpoint, uuid)
      .then(
        metadata => {
          if (metadata && metadata.constraintsUrl) {
            return this.getMaxZoomLevelPercentage(metadata.constraintsUrl)
              .then(
                constraints => {
                  metadata.maxZoomLevelPercentage = (constraints && constraints.maxZoomLevelPercentage) || ''
                  return metadata
                },
                err => {
                  throw err
                }
              )
              .catch(err => {
                throw err
              })
          } else {
            return new Promise(resolve => {
              resolve(metadata)
            })
          }
        },
        err => {
          throw err
        }
      )
      .catch(err => {
        throw err
      })
  },
  getPpiAndConstraintsUrl: function (metaEndpoint, uuid) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', metaEndpoint + uuid, true)
      xhr.onload = () =>
        xhr.status === 200
          ? resolve(this.getMetadataFromResponse(xhr))
          : reject(Error(xhr.statusText + ' ' + xhr.status))
      xhr.onerror = e => reject(e)
      xhr.send(null)
    })
  },
  getMetadataFromResponse: function (xhr) {
    const json = JSON.parse(xhr.responseText)
    const response = json ? json : null
    const author = utility.getField(response, 'autn')
    const title = utility.getField(response, 'sgtt')
    const uuid = utility.getField(response, 'uuid')
    const ppi = utility.getField(utility.getField(response, 'image'), 'ppi')
    const urlConstraints = utility.getField(
      utility.getField(utility.getField(response, '_links'), 'constraints'),
      'href'
    )
    const acquisitionType = utility.getField(utility.getField(response, 'fta'), 'ftap')

    const acquisitionDateString = utility.getField(utility.getField(response, 'fta'), 'ftad')
    const acquisitionDate = acquisitionDateString ? new Date(acquisitionDateString) : null

    const canRotate = utility.getField(response, 'canRotate')

    return {
      ppi: ppi,
      constraintsUrl: urlConstraints,
      author: author,
      title: title,
      uuid: uuid,
      acquisitionType: acquisitionType,
      acquisitionDate: acquisitionDate,
      canRotate: canRotate
    }
  },

  getMaxZoomLevelPercentage: function (constraintsUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', constraintsUrl, true)
      xhr.onload = () =>
        xhr.status === 200
          ? resolve(this.getConstraintsFromResponse(xhr))
          : reject(Error(xhr.statusText + ' ' + xhr.status))
      xhr.onerror = e => reject(e)
      xhr.send(null)
    })
  },
  getConstraintsFromResponse: function (xhr) {
    const json = JSON.parse(xhr.responseText)
    const response = json ? json : null
    let maxZoomLevelPercentage = this.getMaxZoomLevelPercentageFromResponse(response)
    return { maxZoomLevelPercentage: maxZoomLevelPercentage }
  },
  getMaxZoomLevelPercentageFromResponse: function (response) {
    if (response) {
      return response.maxZoomLevelPercentage
    } else {
      return null
    }
  }
}
